import { useContext } from 'react'
import { observer } from 'mobx-react'
import { Tabs } from 'antd'
import { TreeContext, LoadableButton, DelayComponent, Empty } from 'src/components'
import { $consts } from 'src/plugins'

const TreePageMain = () => {
  const tree = useContext(TreeContext)

  const { selectedNodesPageBtns } = tree

  if (!selectedNodesPageBtns.length) {
    return (
      <div className='tree-page__main'>
        <DelayComponent>
          <Empty />
        </DelayComponent>
      </div>
    )
  }

  if (selectedNodesPageBtns.length === 1) {
    return (
      <div className='tree-page__main'>
        <LoadableButton
          key={tree.selectedKeys.join('-')}
          pageType={$consts['TABLE/FORM_TYPE_TREE_PAGE']}
          locateBtn={$consts['TABLE/BTN_LOCATE_PAGER']}
          config={selectedNodesPageBtns[0]}
        />
      </div>
    )
  }

  return (
    <div className='tree-page__main'>
      <Tabs
        size='small'
        items={
          selectedNodesPageBtns.map((btn: any, index: number) => ({
            key: `${btn.ID}_${index}`,
            label: btn.LABEL,
            children: (
              <LoadableButton
                key={tree.selectedKeys.join('-')}
                pageType={$consts['TABLE/FORM_TYPE_TREE_PAGE']}
                locateBtn={$consts['TABLE/BTN_LOCATE_PAGER']}
                config={btn}
              />
            )
          }))
        }
      />
    </div>
  )
}

export default observer(TreePageMain)